module.exports = __webpack_public_path__ + "assets/img/07.69c6ccde.png";